module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_completed-fdd746248d2c3008efeef5b02b640005.svg";